export module UrlUtility {
  export const concatUrlAndQueryParams = (
    url: string,
    params: Record<string, unknown>,
  ):string => {
    const queryString = Object.entries(params).map(([key, value]) => {
      return `${key}=${value}`
    }).join('&')

    return `${url}?${queryString}`
  }
}
